// src/ExpertMarketing.jsx

import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Copy, Eye, Download } from 'lucide-react';

const shareables = [
  {
    label: "Your Booking Link",
    value: "https://quirkleai.com/meet/rajil-patel",
    actions: [Copy, Eye],
  },
  {
    label: "Profile Page",
    value: "https://quirkleai.com/expert/rajil-patel",
    actions: [Copy],
  },
  {
    label: "QR Code",
    value: "/static/qrcode-placeholder.png",
    actions: [Download],
    type: "image",
  },
];

const ExpertMarketing = () => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard!");
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Marketing Toolkit</h1>

      {/* Shareables */}
      <div className="grid md:grid-cols-2 gap-6">
        {shareables.map((item, index) => (
          <Card key={index} className="shadow-sm border bg-white">
            <CardContent className="p-4 space-y-3">
              <p className="text-sm font-medium text-gray-600">{item.label}</p>
              {item.type === "image" ? (
                <img src={item.value} alt="QR Code" className="w-32 h-32" />
              ) : (
                <div className="border rounded-md px-3 py-2 text-sm text-gray-800 bg-gray-50">
                  {item.value}
                </div>
              )}

              <div className="flex gap-2">
                {item.actions.map((ActionIcon, idx) => (
                  <Button
                    key={idx}
                    variant="outline"
                    onClick={() =>
                      ActionIcon === Copy
                        ? handleCopy(item.value)
                        : alert("Feature coming soon!")
                    }
                  >
                    <ActionIcon size={16} className="mr-1" />
                    {ActionIcon === Copy
                      ? "Copy"
                      : ActionIcon === Eye
                      ? "Preview"
                      : "Download"}
                  </Button>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Performance Section */}
      <Card className="shadow-sm border bg-white">
        <CardContent className="p-6 space-y-2">
          <h2 className="text-lg font-semibold">Recent Engagement</h2>
          <p className="text-sm text-gray-600">Here’s how your links performed this week:</p>
          <ul className="text-sm list-disc pl-5 mt-2 text-gray-700">
            <li>34 link clicks to your booking page</li>
            <li>12 new leads from shared profile</li>
            <li>5 QR scans during webinar campaign</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExpertMarketing;
